module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074fb_banner_800x600.a85e72a0.png";